import { FormRenderMode, useFormRuntimeContext } from '../../../form-runtime-context';
import { AddressChange } from '../../create-person-block/shared-components/fields';

type IRenderAddressQuestionProps = {
	questionName: string;
	id: string;
};

export const RenderAddressQuestion = (props: IRenderAddressQuestionProps) => {
	const { questionName, id } = props;
	const { formRenderMode, getAnswer, answerQuestion } = useFormRuntimeContext();
	const answer = getAnswer(questionName)?.answer?.answerJson;

	return (
		<AddressChange
			id={id}
			value={answer ?? ''}
			onChange={e => {
				if (formRenderMode === FormRenderMode.design) {
					return;
				}
				answerQuestion({
					answer: {
						answerJson: e ?? ''
					},
					questionName: questionName
				});
			}}
		/>
	);
};
